module.exports = __webpack_public_path__ + "static/media/lumenlife-logo.c5f90226.jpg";